export default __webpack_public_path__ + "static/media/grafana-icon_light.2f0e10a9.png";